// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/panel-left.js';

import { paths } from '../generated/panel-left';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('panel-left', Original, paths);
